import * as Sentry from "@sentry/astro";

Sentry.init({
	dsn: "https://44379ed084aff47a5724c83dbe66a825@o315385.ingest.us.sentry.io/4510903750950912",

	// Enable performance monitoring
	tracesSampleRate: 1.0,

	// Enable session replay for debugging freezes
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,

	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration({
			maskAllText: false,
			blockAllMedia: false,
		}),
	],

	// Add game context to all events
	beforeSend(event) {
		const params = new URLSearchParams(window.location.search);
		event.extra = {
			...event.extra,
			hasToken: params.has("token"),
			forceResult: params.get("force_result"),
		};
		return event;
	},

	sendDefaultPii: true,
});
